
import "./BillDataDetails.scss";
import formatNumberWithCommas from "../format/formatNumberWithCommas";

const BillDetails = ({ billData }) => {
  return (
    <div className="frame-layout-bill">
      <h1>{billData.Brand}</h1>
      <h4>{billData.Address}</h4>
      <h4>{billData.Phone}</h4>
      <h4>{billData.Line}*********************</h4>
      <h3>{billData.Bill}</h3>

      <table>
        <thead>
          <tr>
            <th>Tên</th>
            <th style={{ textAlign: "center" }}>Giá</th>
            <th style={{ textAlign: "center" }}>Số Lượng</th>
            <th style={{ textAlign: "center" }}>Tổng</th>
          </tr>
        </thead>
        <div></div>
        <tbody>
          {billData.OrderList.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td style={{ textAlign: "center" }}>
                {formatNumberWithCommas(item.price)}
              </td>
              <td style={{ textAlign: "center" }}>{item.totalItem}</td>
              <td style={{ textAlign: "center" }}>
                {formatNumberWithCommas(item.totalPrice)}
              </td>
            </tr>
          ))}
        </tbody>
        <tbody>
          <tr>
            <td>Thời Gian</td>
            <td style={{ textAlign: "center" }}>
              {formatNumberWithCommas(billData.PriceOfTime)}
            </td>
            <td style={{ textAlign: "center" }}>{billData.TotalTime}</td>
            <td style={{ textAlign: "center" }}>
              {formatNumberWithCommas(billData.PriceOfTotalTime)}
            </td>
          </tr>
        </tbody>
      </table>

      <div className="frame-qr-total-bill">

        <div className="frame-qr">
          <img
            src={`https://img.vietqr.io/image/MB-0001120490029-qr_only.png?amount=${billData.TotalPayment}&addInfo=${billData.qrContent}&accountName=Chau%20Hoai%20Vu`}
            alt=""
          />
        </div>

        <div className="frame-square-total-payment-billDetails">
          <h4 className="front-total-price-billDetails">
            Tổng Tiền : {formatNumberWithCommas(billData.TotalPayment)} vnđ
          </h4>
          <h6>{billData.Date}</h6>
          <h6>{billData.Debt}</h6>
        </div>

      </div>


      <h4>{billData.Line}*********************</h4>
      <h5>{billData.Goodbye}</h5>
      <h5>{billData.SubGoodbye}</h5>
    </div>
  );
};

export default BillDetails;
